<template>
  <v-dialog v-model="showUploadVideo" persistent width="1220" scrollable>
    <v-card>
      <v-card-title
        style="border-bottom: 1px solid #0000001f;"
        class="d-flex align-center px-4 justify-space-between"
      >
        <div>
          <v-icon color="#424242" class="mr-2">mdi-plus-box-outline</v-icon>
          <span style="font-size: 20px; color: #424242;">{{
            "Edit Video"
          }}</span>
        </div>
        <v-btn
          icon
          @click="ResetVideoDialog()"
          color="#424242"
          style="
                border-radius: 8px !important;
                border: 1px solid rgba(66, 66, 66, 0.05);
              "
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text style="height: 400px">
        <v-row class="mt-5">
          <v-col cols="12" xs="12" sm="12" md="6" lg="6">
            <div>
              <label for="title" class="font-style">{{ $t("title") }}</label>
              <v-text-field
                outlined
                dense
                hide-details="auto"
                id="title"
                :rules="videoTitleRules"
                class="rounded-lg"
                v-model="video_title"
                :error-messages="titleError"
              ></v-text-field>
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6">
            <CoverImageUploader
              :editImageSrc="pictureBackground"
              @GetImageData="GetImageDataForAddNewVideo"
              :fileError="fileError"
            />
          </v-col>
        </v-row>
        <v-progress-circular
          v-if="video_loading"
          indeterminate
          class="loading-circle"
          color="green"
        ></v-progress-circular>
        <v-row>
          <v-col cols="12">
            <v-row justify="end" style="margin-right: 1px">
              <input
                type="file"
                accept="video/mp4"
                class="d-none"
                ref="video"
                @change="getVideo"
              />
              <v-btn
                color="secondary"
                class="text-capitalize white--text select btn_hover_effect"
                width="150"
                :disabled="addBtnEnable"
                style="font-size: 16px"
                @click="$refs.video.click()"
              >
                {{ $t("additem") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="videoDialogHeaders"
              :items="VideoDialogList"
              class="vd_class"
              hide-default-footer
              no-data-text="No data available"
            >
              <template v-slot:item.id="{ item }">{{ item.no }}</template>
              <template v-slot:item.popupTime="{ item }">
                <tr>
                  <td>
                    <div style="width: 60px !important; margin-left: 5px">
                      <v-text-field
                        solo
                        class="popUp-submit"
                        hide-spin-buttons
                        hide-details
                        value="0"
                        type="number"
                        :class="{ 'red-border': showRedBorder }"
                        v-model="item.popupTime"
                        @input="checkPopUpTime(item.popupTime, item)"
                      ></v-text-field>
                      <!-- :error-messages="popupTimeError(item)" -->
                    </div>
                  </td>
                  <td class="pl-3">{{ "Min." }}</td>
                </tr>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  color="#FF6060"
                  style="font-size: 16px"
                  class="text-capitalize"
                  text
                  @click="deleteVideoList(item.no)"
                >
                  <v-icon>mdi-delete-outline</v-icon>
                  {{ $t("delete") }}
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions
        class="py-3 px-4"
        style="border-top: 1px solid #0000001f;"
      >
        <v-spacer></v-spacer>
        <v-btn
          class="text-capitalize btn-font-s16"
          style="
                border: 1px solid #c0c0c0;
                border-radius: 8px;
                color: #424242;
              "
          text
          outlined
          @click="ResetVideoDialog()"
          >{{ $t("cancel") }}</v-btn
        >
        <v-btn
          class="text-capitalize white--text btn-font-s16 btn_hover_effect"
          color="#a6cc39"
          width="120"
          style="
                border: 1px solid #a6cc39;
                border-radius: 8px;
                font-size: 16px;
              "
          @click="updateVideo()"
          >{{ $t("submit") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import EnUrl from "@/api/environment";
import CoverImageUploader from "../../../../components/CoverImageUploader.vue";

export default {
  components: {
    CoverImageUploader
  },
  props: {
    ShowVideoDialog: {
      type: Boolean,
      default: false
    },
    EditItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      //add_new_vid: false,
      EditVdoInfo: {},
      course_ID: 0,
      pictureBackground: "",
      showRedBorder: false,
      actualDuration: "",
      apiUrlV1: EnUrl.apiUrl,
      apiUrlV6: EnUrl.apiUrlV6,
      //..............
      video_title: "",
      titleError: "",
      imageError: "",
      VideoDialogList: [],
      //...............................................
      FlagCheck: false,
      fileError: false,
      //...........
      video_loading: false,
      addBtnEnable: false,
      videoImageCover: {
        name: null,
        file: null
      }
    };
  },
  computed: {
    videoTitleRules() {
      return [v => !!v || "Title is required"];
    },
    showUploadVideo: {
      get() {
        return this.ShowVideoDialog;
      },
      set() {
        this.$emit("close");
      }
    },
    videoDialogHeaders() {
      return [
        {
          text: "#",
          sortable: false,
          value: "id"
        },
        {
          text: "File Name",
          sortable: false,
          value: "videoName"
        },
        {
          text: "Set Popup Time",
          sortable: false,
          value: "popupTime"
        },
        {
          text: "Time",
          sortable: false,
          value: "duration"
        },
        {
          text: "Size",
          sortable: false,
          value: "size"
        },
        {
          text: "Action",
          sortable: false,
          value: "actions",
          align: "center"
        }
      ];
    }
  },

  watch: {
    EditItem: {
      handler(newVal) {
        // You can handle the update here as needed
        this.video_title = newVal.title;
        this.pictureBackground = newVal.pictureBackground;

        this.VideoDialogList.push({
          id: newVal.id,
          assignmentCourseID: newVal.assignmentCourseID,
          oldID: newVal.oldID,
          oldVideoID: newVal.oldVideoID,
          startContentDate: newVal.startContentDate,
          endContentDate: newVal.endContentDate,
          title: newVal.title,
          size: newVal.size,
          description: newVal.description,
          popupTime: newVal.popupTime,
          duration: newVal.duration,
          videoFile: newVal.videoFile,
          videoName: newVal.videoName,
          allowDownload: newVal.allowDownload,
          imgBase64: "",
          pictureBackground: newVal.pictureBackground,
          permissionList: [],
          no: newVal.no
        });
        this.addBtnEnable = true;
      },
      deep: true, // Watches nested properties of EditItem
      immediate: true // Trigger immediately if you want to run on initial load
    }
  },

  mounted() {},

  methods: {
    timeInSeconds(timeString) {
      const timeParts = timeString.split(":");
      let hours = 0;
      let minutes = 0;
      let seconds = 0;

      if (timeParts.length === 2) {
        // Format: mm:ss
        minutes = parseInt(timeParts[0]);
        seconds = parseInt(timeParts[1]);
      } else if (timeParts.length === 3) {
        // Format: HH:MM:SS
        hours = parseInt(timeParts[0]);
        minutes = parseInt(timeParts[1]);
        seconds = parseInt(timeParts[2]);
      }
      return hours * 3600 + minutes * 60 + seconds;
    },

    formatDuration(duration) {
      let time = [
        Math.floor(duration / 60) + "",
        Math.floor(duration % 60) + ""
      ];
      time.forEach(value => {
        while (value.length < 2) value = "0" + value;
      });
      return `${time[0]}:${time[1]}`;
    },

    deleteVideoList(id) {
      this.VideoDialogList.splice(
        this.VideoDialogList.findIndex(item => item.no === id),
        1
      );
      this.addBtnEnable = false;
    },

    checkPopUpTime(popupMin, item) {
      let second = popupMin * 60;
      let videoSeconds = this.timeInSeconds(item.duration);

      if (second > videoSeconds || second < 0) {
        this.$nextTick(() => {
          this.showRedBorder = true;
          this.popUpTimeExceed = true;
          this.VideoDialogList.find(x => x.no === item.no).popupTime = 0;
        });
      } else {
        this.showRedBorder = false;
      }
    },

    async getVideo(e) {
      const file = e.target.files ? e.target.files[0] : null;

      if (!file) {
        console.error("File not found or undefined");
        return;
      }

      let that = this;
      let videoDuration = "";
      that.video_loading = true;

      let filesize = e.target.files[0].size;
      if (filesize <= 157286400) {
        that.addBtnEnable = true;

        let formData = new FormData();
        formData.append("file", e.target.files[0]);

        const video = document.createElement("video");
        video.src = URL.createObjectURL(e.target.files[0]); // Set the source before adding event listener

        video.addEventListener("loadedmetadata", () => {
          videoDuration = that.formatDuration(video.duration) + "m";

          that.VideoDialogList.push({
            id: that.EditItem.id !== 0 ? that.EditItem.id : 0,
            assignmentCourseID:
              that.EditItem.assignmentCourseID !== 0
                ? that.EditItem.assignmentCourseID
                : that.course_ID,
            oldID: 0,
            oldVideoID: 0,
            startContentDate: new Date(),
            endContentDate: new Date(),
            videoName: file.name,
            title: that.video_title,
            description: "",
            size: parseFloat(file.size / (1024 * 1024)).toFixed(2) + "MB",
            popupTime: 0,
            duration: videoDuration,
            videoFile: formData, // res.data.data, i think video should be upload only when submit
            allowDownload: true,
            imgBase64: "",
            pictureBackground: "",
            permissionList: [],
            no: that.EditItem.no !== 0 ? that.EditItem.no : 0
            // that.$store.state.assignmentUser.courseVideoList.length + 1
          });
          //that.add_new_vid = true;
        });
      } else {
        alert("Your file size is over 150MB!");
      }
      that.video_loading = false;
      e.target.value = null;
    },

    //........................................................................

    validateTitle() {
      this.titleError = this.video_title ? "" : "Title is required";
    },

    // popupTimeError(item) {
    //   return item.popupTime ? "" : "Popup time is required";
    // },

    isBlobUrl(url) {
      const blobUrlPattern = /^https:\/\/.*\.blob\.core\.windows\.net\/.*\.(png|jpg|jpeg|gif|mp4)(\?.*)?$/i;
      return blobUrlPattern.test(url);
    },

    async updateVideo() {
      let imgUrl64 = null;
      let videoUrl = null;
      // Validate the title and set `this.titleError` accordingly
      this.validateTitle();

      // Check if the video image cover is missing
      const imageError =
        this.pictureBackground === null && !this.videoImageCover.file;
      // Check if there are items in the VideoDialogList
      const isDataTableValid = this.VideoDialogList.length > 0;
      // Set the file error state based on the image validation result
      this.fileError = imageError;

      // Combine all validation checks
      if (!this.titleError && !imageError && isDataTableValid) {
        // All validations passed
        this.video_loading = true;
        let vidFile = this.VideoDialogList[0]?.videoFile ?? null;
        let result = this.isBlobUrl(vidFile);
        if (!this.isBlobUrl(vidFile)) {
          const res_v = await axios.post(
            `${this.apiUrlV1}File/UploadFile`,
            vidFile
          );
          videoUrl = res_v.data.data;
        } else {
          videoUrl = vidFile;
        }

        if (this.videoImageCover.file !== null) {
          const res_img = await axios.post(
            `${this.apiUrlV1}File/UploadFileStringBase`,
            {
              base64: this.videoImageCover.file,
              fileName: this.videoImageCover.name
            }
          );
          imgUrl64 = res_img.data;
        } else {
          imgUrl64 = this.isBlobUrl(this.pictureBackground)
            ? this.pictureBackground
            : null;
        }

        let videoList = this.VideoDialogList.map(x => ({
          ...x,
          title: this.video_title,
          videoFile: videoUrl,
          imgBase64: imgUrl64,
          pictureBackground:
            this.videoImageCover.file !== null
              ? this.videoImageCover.file
              : this.pictureBackground,
          imgBlobUrl: imgUrl64
        }));

        this.$store.commit("updateInCourseVideoList", videoList[0]);
        this.video_loading = false;
        this.ResetVideoDialog();
      } else {
        // At least one validation failed
        if (!isDataTableValid) {
          alert("Please add course video!");
        } else {
          alert("Please fill title and image cover!");
        }
      }
    },

    ResetVideoDialog() {
      this.pictureBackground = "";
      this.video_title = null;
      this.VideoDialogList = [];
      this.addBtnEnable = false;
      this.videoImageCover = {
        name: null,
        file: null
      };
      this.video_loading = false;
      this.showUploadVideo = false;
    },

    GetImageDataForAddNewVideo(v) {
      this.videoImageCover.file = v.file;
      this.videoImageCover.name = v.name;
      this.fileError = v.file === null;
    }
  }
};
</script>

<style scoped>
::v-deep .popUp-submit.v-text-field.v-text-field--solo .v-input__control {
  min-height: 27px;
  padding: 0;
}
::v-deep .popUp-submit .v-input__slot {
  border-radius: 4px !important;
}
</style>
